import { useContext } from 'react';
import { FilterContext } from "./FilterContext.js";
export var useFilterContext = function () {
    return useContext(FilterContext);
};
//# sourceMappingURL=useFilterContext.js.map